// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalStyles_modalContainer__S2RwC","modalMainBlk":"ModalStyles_modalMainBlk__OHR3J","disabled":"ModalStyles_disabled__FkQVl"};